import { CheckIcon } from "@chakra-ui/icons";
import { Button, Tooltip } from "@chakra-ui/react";
import Select from "../../../shared/components/Select";
import { HHAXPocItemId } from "../../../shared/schema/schema";
import { UNMAPPED_MARKER } from "../evv-duty-code-mapping.utils";
import { HHAXViewProps, PlanOfCareColumn } from "../hhax-poc-mapping.types";

export default function HhaxMappingRow(
  props: HHAXViewProps & {
    column: PlanOfCareColumn;
  }
) {
  const key = String(props.column.id);
  const saved = props.mappedHhaxItemIdOf(props.column);
  const draft = props.draftMappings[key];
  const selected: HHAXPocItemId | null = draft === undefined ? saved : draft;
  const isDirty = selected !== saved;
  const isSaving = props.savingPlanOfCareItemId === props.column.id;
  // Flags what is saved for the selected payer, not the pending draft.
  const isUnmapped = saved === null;

  return (
    <tr>
      <td>{props.column.section}</td>
      <td>
        {props.column.label}
        {isUnmapped && (
          <Tooltip label="Not mapped to an HHAeXchange task for this payer">
            <span> {UNMAPPED_MARKER}</span>
          </Tooltip>
        )}
      </td>
      <td>{props.column.code}</td>
      <td>
        <Select
          allowUnselect
          searchable
          buttonProps={{ width: "100%" }}
          isDisabled={props.hhaxItemOptions.length === 0}
          label="HHAeXchange task"
          multiple={false}
          options={props.hhaxItemOptions}
          size="sm"
          value={selected}
          width="360px"
          onChange={(value) => props.onChangeDraftMapping(props.column.id, value)}
        />
      </td>
      <td>
        <Button
          colorScheme="blue"
          isDisabled={!isDirty || isSaving}
          isLoading={isSaving}
          leftIcon={<CheckIcon />}
          size="sm"
          onClick={() => props.onSave(props.column, selected)}
        >
          Save
        </Button>
      </td>
    </tr>
  );
}
